<template>
    <Popup 
    :modelValue=displayingForm 
    @update:model-value=closeChild
    title="Create New Multiple Period Report:"
    hasClose
    >
        <template #contents>
            <div class="form-container">
                <form class="two-column" @submit.prevent=confirmPeriods>
                    <div class="description-subtitle">
                        <label for=startPeriodSelector>
                            Start Period:
                        </label>
                        <PeriodSelector
                            ref=startPeriodSelector
                            id=startPeriodSelector
                            class="col2 select"
                            type="text"
                            title="Select start period"
                            v-model=startPeriod
                        />
                        <label for=endPeriodSelector>
                            End Period:
                        </label>
                        <PeriodSelector 
                            ref=endPeriodSelector
                            id=endPeriodSelector
                            class="col2 select"
                            type="text"
                            title="Select end period"
                            v-model=endPeriod
                        />
                    </div>
                    <div class="button-group" >
                        <button :disabled=working
                            class="confirm-button" 
                            type="submit"
                        >
                            Confirm
                        </button>
                    </div>  
                </form>
            </div>
        </template>
    </Popup>
</template>

<script setup lang="ts">
import '@vuepic/vue-datepicker/dist/main.css';
import {ref,computed} from 'vue';
import Popup from '@/components/Popup.vue';
import PeriodSelector from '@/components/PeriodSelector.vue';
import DatePeriod from '@/types/DatePeriod';
import useNotifierWithErrFormatter from '@/services/composables/NotifierWithErrFormatter';

const props = defineProps<{
    modelValue: boolean;
    period: string;
}>();
const emits = defineEmits<{
    (e:'update:modelValue', val: boolean): void;
    (e:'confirm', startP: DatePeriod, endP: DatePeriod) : void;
}>();
const displayingForm = computed({
    get(){
        return props.modelValue;
    },
    set(val: boolean) {
        emits('update:modelValue', val);
    }
});
const working = ref(false);
const startPeriod = ref<DatePeriod>(new DatePeriod(props.period ? new Date(props.period) : new Date().addMonths(-1)));
const endPeriod = ref<DatePeriod>(new DatePeriod(props.period ? new Date(props.period) : new Date().addMonths(-1)));
function closeChild() {
    displayingForm.value = false;
}
function validatePeriods(startP : DatePeriod, endP : DatePeriod) {
    let validationResult = true;
    if( !!startP && !!endP) {
        if (endP < startP) {
            validationResult = false;
            useNotifierWithErrFormatter().warn({
                msg: "End Period must not be earlier than Start Period"
            })
        }
    }
    else {validationResult = false}
    return validationResult;
}
async function confirmPeriods() {
    if (!validatePeriods(startPeriod.value, endPeriod.value) ) return;
    emits('confirm', startPeriod.value, endPeriod.value);
    emits('update:modelValue', false);
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/centre-button.scss";

.description-title {
    font-size: 1.3rem;
    text-align: center;
}

.description-subtitle {
    display: grid;
    grid-auto-flow: dense;
    row-gap: 0.5lh;
    column-gap: 2ch;
    text-align: center;
}
.col2 {
    grid-column-start: 2;
}
.description-subtitle :deep(input) {
    font-size: .8rem;
    border-radius: .4rem;
    padding-left: .6rem;
    padding-top: .2rem;
    padding-bottom: .2rem;
    grid-column-start: 2;
}
.description-subtitle :deep(select) {
    font-size: .8rem;
    border-radius: .4rem;
    padding-left: .6rem;
    padding-top: .2rem;
    padding-bottom: .2rem;
    grid-column-start: 2;
}
.label {
    display: flex;
    align-items: center;
    grid-column-start: 1;
    vertical-align: middle;
}
.label-bold {
    vertical-align: middle;
    font-weight: bold;
}
.button-group {
    display: flex;
    flex-direction: column;
    row-gap: 0.3rem;
}
.confirm-button {
    border-width: 0px;
    border-radius: var(--buttons-border-radius);
    background-color: var(--primary-color-lighter);
    padding: 10px;
    color: blue;
    font-size: larger;
    font-weight: bold;
    width: 100%;
}
.confirm-button:hover {
    background-color: var(--primary-color);
    color: white;
    cursor: pointer;
}
.confirm-button:disabled {
    color: #b6b6b6;
    background-color: var(--light-grey);
}
.confirm-button:disabled:hover {
    background-color: var(--primary-color-lighter);
    cursor: not-allowed;
}
.two-column {
    display: flex;
    flex-direction: column;
    row-gap: 1rem;
    background-color: white;
    overflow-y: auto;
    label {
        display: flex;
        align-items: center;
        grid-column-start: 1;
    }
}
</style>


<!-- 


:deep(.invalid-input:invalid) {
    color: red; border-color: red; outline: none;
}
.tab-button-left {
    border-radius: var(--topbar-sidebar-content-radius) 0px 0px 0px;
    padding-left: 2rem;
}
.tab-button-right {
    border-radius: 0px var(--topbar-sidebar-content-radius) 0px 0px;
    padding-right: 2rem;
}
.button-group {
    display: flex;
    flex-direction: column;
    row-gap: 0.3rem;
}
.bottom-margin-only {
    margin-top: 0px;
    margin-left: 0px;
    margin-right: 0px;
    margin-bottom: 10px;
}
.center-buttons button:disabled {
    color: blue;
    background-color: var(--light-grey);
}
.center-buttons-button-disabled:disabled {
    color: var(--primary-color-dark) !important;
    background-color: var(--light-grey);
}
.selected {
    background-color: var(--primary-color-lighter) !important;
    border-width: 0 0 .2rem 0;
    border-color: blue;
}
.unselected {
    color: #b6b6b6;
    background-color: #f0f0f0;
    font-weight: normal;
    border-color: white;
}
.confirm-button {
    border-width: 0px;
    border-radius: var(--buttons-border-radius);
    background-color: var(--primary-color-lighter);
    padding: 10px;
    color: blue;
    font-size: larger;
    font-weight: bold;
    width: 100%;
}
.confirm-button:hover {
    background-color: var(--primary-color);
    color: white;
    cursor: pointer;
}
.confirm-button:disabled {
    color: #b6b6b6;
    background-color: var(--light-grey);
}
.confirm-button:disabled:hover {
    background-color: var(--primary-color-lighter);
    cursor: not-allowed;
}
.delete-button {
    margin-top: 10px;
    border-width: 0px;
    border-radius: var(--buttons-border-radius);
    background-color: var(--red-background-color);
    padding: 10px;
    color: red;
    font-size: larger;
    font-weight: bold;
    width: 100%;
}
.delete-button:hover {
    background-color: red;
    color: white;
    cursor: pointer;
}




.wrap {
    white-space: pre-line;
}
.anw-info-textbox {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 1rem;
}
.details-column {
    width: 33.33%;
    float: left;
    padding: .4rem;
}
.details-column-title {
    font-size: large;
    font-weight: bold;
    text-align: center;
    color: var(--primary-color-dark);
}



.form-container {
    flex: 1 1 auto;
    >.error {
        vertical-align: middle;
        text-align: center;
    }
    >form.two-column {
        display: grid;
        row-gap: 0.25rem;
        column-gap: 0.5rem;
        grid-template-columns: auto auto;
        align-items: center;

        >label {
            text-align: left;
            vertical-align: middle;
        }
        .input,
        :deep(input),
        :deep(select),
        select {
            border-color: black;
            font-size: 0.8rem;
            border-radius: 0.4rem;
            padding-top: 0.2rem;
            padding-bottom: 0.2rem;
            border-width: 2px;
            text-align: left;
        }
        select:invalid,
        select option[value=""] {
            color: grey;
        }
        select option {
            color: black;
        }
        >.confirm-button {
            margin-top: 10px;
            border-width: 0px;
            border-radius: var(--buttons-border-radius);
            background-color: var(--primary-color-lighter);
            padding: 10px;
            color: blue;
            font-size: larger;
            font-weight: bold;
            width: 100%;
            grid-column: span 2;
            &:hover {
                background-color: var(--primary-color);
                color: white;
                cursor: pointer;
            }
            &:disabled {
                color: #b6b6b6;
                background-color: var(--light-grey);
                &:hover {
                    background-color: var(--primary-color-lighter);
                    cursor: not-allowed;
                }
            }
        }
    }
}
    

-->